import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '!p-0',
    imageWrapper:
      'bg-accent flex aspect-square h-full w-full min-w-screen shrink-0 grow-0 items-center',
    image: '!pointer-events-auto object-contain',
    arrow: 'border-0',
    viewport: 'relative overflow-hidden',
    container: 'flex h-screen items-center',
    thumbs:
      'absolute bottom-15 z-10 flex gap-2 lg:top-1/2 lg:bottom-auto lg:left-20 lg:-translate-y-1/2 lg:transform lg:flex-col lg:items-center',
    thumb: 'aspect-square w-full object-contain',
    thumbsViewport: 'w-screen overflow-hidden lg:h-108 lg:w-auto',
    thumbsContainer: 'mx-3 flex gap-2 lg:h-108 lg:flex-col',
    thumbArrow:
      'text-main z-10 hidden h-6 border-0 p-0 hover:bg-inherit lg:block',
    thumbArrowIcon: 'hover:[&>path]:stroke-icon-brand h-5 w-3',
    video: 'h-full object-contain lg:object-cover',
    closeButton:
      'top-4 right-4 z-10 !border-0 !outline-0 hover:!border-0 lg:top-7 lg:right-7',
    closeIconButton: 'hover:[&>path]:stroke-icon-brand size-10'
  },
  variants: {
    zoom: {
      true: {
        thumbs: 'hidden lg:flex',
        image: 'overflow-visible max-lg:!pointer-events-auto',
        imageWrapper: 'h-screen cursor-zoom-out lg:cursor-move',
        container: 'relative z-1'
      },
      false: {
        viewport: '-mt-23 lg:mt-0',
        imageWrapper: 'cursor-zoom-in'
      }
    },
    hide: {
      true: {
        arrow: 'opacity-0',
        thumbArrow: 'opacity-0'
      }
    }
  }
});
